export default {
  computed: {
    fondo() {
      return this.$store.getters.editingLinckard.style.sobre.fondo
    },
  },
  methods: {
    updateFondoKey({ key, value }) {
      const newLinckard = JSON.parse(JSON.stringify(this.$store.getters.editingLinckard))
      newLinckard.style.sobre.fondo[key] = value
      this.$store.commit('changeActiveEdit', newLinckard)
    },
    handleVideoSelection(hasVideo) {
      this.updateFondoKey({ key: 'active', value: !hasVideo })
    },
  },
}
